export default __webpack_public_path__ + "assets/icons/icon-close.0981f83ef8f9040a751b4bb5de0082bf.svg";